// extracted by mini-css-extract-plugin
export var askAiIcon = "_md-j";
export var category = "_md-9";
export var categoryHeader = "_md-e";
export var container = "_md-0";
export var group = "_md-a";
export var groupItems = "_md-f";
export var groupSeparator = "_md-k";
export var loading = "_md-1";
export var noResults = "_md-3";
export var placeholder = "_md-2";
export var resultContent = "_md-5";
export var resultIcon = "_md-c";
export var resultItem = "_md-g";
export var resultMeta = "_md-8";
export var resultSubtitle = "_md-7";
export var resultSuffix = "_md-i";
export var resultTitle = "_md-6";
export var resultsList = "_md-4";
export var searchGroup = "_md-d";
export var selected = "_md-h";
export var subgroup = "_md-b";